import script from "./OperlogDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./OperlogDetail.vue?vue&type=script&setup=true&lang=js"

import "./OperlogDetail.vue?vue&type=style&index=0&id=b266269a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b266269a"]])

export default __exports__